module.exports=function(scope){ return `<ul class="mdl-list"></ul>`};